import { z } from 'zod';
import { isValidPostalCode, normalizePostalCode, isValidHouseNumber, normalizeHouseNumber, cleanText } from '@/lib/address';

export const quoteSchema = z.object({
	system_surface_area: z
		.union([z.string().length(0), z.coerce.number().min(1, 'Oppervlakte moet groter zijn dan 0')])
		.optional()
		.transform((v) => (v === '' ? undefined : v)),
	system_isolation_level: z.enum(['slecht', 'matig', 'goed', 'zeer_goed']).optional(),
	location_photo: z.array(z.any()).max(5, "Maximaal 5 foto's toegestaan").optional(),
	location_remarks: z.string().optional(),
	location_street: z.string().min(2, 'Straat is verplicht').transform(cleanText),
	location_house_number: z
		.string()
		.min(1, 'Huisnummer is verplicht')
		.refine(isValidHouseNumber, { message: 'Huisnummer moet met een cijfer beginnen (bijv. 12A)' })
		.transform(normalizeHouseNumber),
	location_postal_code: z
		.string()
		.min(1, 'Postcode is verplicht')
		.refine(isValidPostalCode, { message: 'Ongeldige postcode. Bijv. 1234 AB.' })
		.transform(normalizePostalCode),
	location_city: z.string().min(2, 'Plaats is verplicht').transform(cleanText),
	contact_name: z.string().min(2, 'Naam is verplicht'),
	contact_email: z.string().email('Ongeldig e-mailadres'),
	contact_phone: z.string().min(10, 'Vul een geldig telefoonnummer in'),
	privacy_agreed: z
		.boolean()
		.refine((val) => val === true, { message: 'U moet akkoord gaan met de privacyverklaring' }),
	token: z.string().optional(),
});

export type QuoteFormSchema = z.infer<typeof quoteSchema>;
